import React, { useState } from 'react';
import {
    Box, Button, Checkbox, FormControlLabel, Paper, Stack, TextField, Typography,
} from '@mui/material';
import { Technika } from '../../../api/JsdhNotifikaceService/generated/models/Technika';
import { useObsazeniNahledMutation } from '../../../api/JsdhNotifikaceService/service/ObsazeniHooks';
import ObsazeniVysledekView from '../../../components/obsazeni/ObsazeniVysledekView';

interface Props {
    vozidla: Technika[];
}

const ObsazeniNahledPanel: React.FC<Props> = ({ vozidla }) => {
    const [vybrane, setVybrane] = useState<number[]>([]);
    const [pocetVelitelu, setPocetVelitelu] = useState(1);
    const [pocetStrojniku, setPocetStrojniku] = useState(1);
    const [pocetHasicu, setPocetHasicu] = useState(4);
    const nahled = useObsazeniNahledMutation();

    const toggle = (id: number) =>
        setVybrane((prev) => (prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]));

    const spocitat = () =>
        nahled.mutate({
            technikaIds: vybrane,
            pocetVelitelu,
            pocetStrojniku,
            pocetHasicu,
        });

    return (
        <Paper sx={{ p: 2, mt: 3 }}>
            <Typography variant="h6" gutterBottom>
                Náhled plnění vozidel (ukázka)
            </Typography>
            <Typography variant="body2" color="text.secondary" gutterBottom>
                Vyberte vozidla a zadejte fiktivní počty osob — uvidíte, jak se rozřadí podle nastavení.
            </Typography>

            <Box sx={{ my: 1 }}>
                <Typography variant="subtitle2">Vozidla</Typography>
                <Stack direction="row" flexWrap="wrap" useFlexGap>
                    {vozidla.map((v) => (
                        <FormControlLabel
                            key={v.id}
                            control={<Checkbox checked={vybrane.includes(v.id)} onChange={() => toggle(v.id)} />}
                            label={`${v.volaciZnak} — ${v.nazev}`}
                        />
                    ))}
                </Stack>
            </Box>

            <Stack direction="row" spacing={2} sx={{ my: 1 }} flexWrap="wrap" useFlexGap>
                <TextField label="Velitelé" type="number" value={pocetVelitelu}
                    onChange={(e) => setPocetVelitelu(Number(e.target.value))} inputProps={{ min: 0 }} sx={{ width: 120 }} />
                <TextField label="Strojníci" type="number" value={pocetStrojniku}
                    onChange={(e) => setPocetStrojniku(Number(e.target.value))} inputProps={{ min: 0 }} sx={{ width: 120 }} />
                <TextField label="Hasiči" type="number" value={pocetHasicu}
                    onChange={(e) => setPocetHasicu(Number(e.target.value))} inputProps={{ min: 0 }} sx={{ width: 120 }} />
            </Stack>

            <Button variant="contained" onClick={spocitat} disabled={vybrane.length === 0 || nahled.isPending}>
                Spočítat náhled
            </Button>

            <Box sx={{ mt: 2 }} data-testid="obsazeni-nahled-vysledek">
                {nahled.data && <ObsazeniVysledekView data={nahled.data} />}
            </Box>
        </Paper>
    );
};

export default ObsazeniNahledPanel;
